import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Button } from '../../../common/html/button'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { PopupContactUs } from '../../../common/order/popup/popupContactUs'
import { ScrollComponent } from '../../../common/scrollComponent'
import { Footer } from '../../../layout/footer'
import classes from './index.module.scss'
import './lang/i18n'
import { PreviewLeft } from './previewLeft'
import { PreviewRight } from './previewRight'
import { selectCompanyInfoData } from './store/slice'

export const Content = () => {
  // Use selector
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectCompanyInfoData)

  // Use state
  const [isOpenPopupContactUs, setIsOpenPopupContactUs] = useState(false)

  // Get data
  const getTheCompanyDetailSourced = useMemo(() => {
    return I18n.t(
      'domesticSearchPreview.THE_COMPANY_DETAIL_FOR_SOURCED',
    ).replace(
      '[organizationName]',
      (data?.organizationName || '').toUpperCase(),
    )
  }, [data, locale])

  // Actions
  const onOpenPopupContactUs = () => {
    setIsOpenPopupContactUs(true)
  }

  const onClosePopupContactUs = () => {
    setIsOpenPopupContactUs(false)
  }

  return (
    <div className="h100">
      <ScrollComponent>
        <div className="flexColumn h100">
          <div className="flex1 px3 pb3">
            <div className="dFlex alignItemsCenter justifyContentBetween my1">
              <Element
                elementName="div"
                className="textUppercase"
                style={{ color: '#0553A5', fontSize: 24 }}
              >
                {data?.organizationName}
              </Element>
              <Button
                label={
                  <div className="dFlex alignItemsCenter">
                    <span className="whiteSpaceNowrap">
                      <Translate value="domesticSearchPreview.CONTACT_US" />
                    </span>
                    <Icon
                      className="icon-arrow-right ml1"
                      style={{ fontSize: 10 }}
                    />
                  </div>
                }
                className={classes.contactUsButton}
                style={{ backgroundColor: '#F3F3F3' }}
                action={onOpenPopupContactUs}
              />
            </div>
            <div className={classes.domesticSearchPreview}>
              <div className="w30">
                <PreviewLeft />
              </div>
              <div className="w70">
                <PreviewRight />
              </div>
            </div>
            <div className={classes.divider}></div>
            <span className="fstItalic">{getTheCompanyDetailSourced}</span>
            <PopupContactUs
              isOpen={isOpenPopupContactUs}
              onClose={onClosePopupContactUs}
            />
          </div>
          <Footer />
        </div>
      </ScrollComponent>
    </div>
  )
}
